import React from "react";
import "./Footer.css";
export default function gitUrl() {
  return (
    <div>
      <a
        className="git-url"
        href="https://github.com/mayza-ferreira/weather-react-app"
      >
        Open-source coded
      </a>
      <span> by Mayza Ferreira.</span>
    </div>
  );
}
